var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-v2"},[(_vm.structureImage)?_c('div',{staticClass:"structure-img"},[_c('img',{attrs:{"src":_vm.structureImage,"alt":"组织架构图"}})]):_c('div',{staticClass:"empty-v2"},[_vm._v("暂无组织架构图")])])
}
var staticRenderFns = []

export { render, staticRenderFns }